/**
 * Normalize pathname to remove PII (UUIDs, numeric IDs)
 * Examples:
 *   /flows/abc-123-def/employees/456 → /flows/?/employees/?
 *   /employee-management/789 → /employee-management/?
 */
export function normalizePath(path: string): string {
  return (
    path
      // Replace UUIDs with ?
      .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/?')
      // Replace numeric IDs with ?
      .replace(/\/\d+/g, '/?')
      // Replace URL-safe base64 tokens with ?
      .replace(/\/[A-Za-z0-9_-]{20,}/g, '/?')
  );
}
